var ctWarnFunc={
	stayWar:function(ele){
		var checkInRef=$(ele).parents().find('.checkin_date');
		if(checkInRef.val() !==""){
		    var checkIn=moment(checkInRef.nextAll("input").val(), "DD/MM/YYYY");
		    if($(ele).val() != '') {
			    var checkOut= moment($(ele).nextAll("input").val(), "DD/MM/YYYY");
			    var dayStay=checkOut.diff(checkIn,"days");
			    $(ele).parents(".searchForm").find(".indicator").html("");
				if(dayStay>CT.settings.hotel.lengthOfStay){
					return dayStay;
				} else{
					false;
				}
			}
		}

	},
	totalDur:function(ele){
		if($(ele).val() !== '') { 
			var checkInRef=moment($(ele).nextAll("input").val(), "DD/MM/YYYY");
    		var currDate=new moment();
    		var total=checkInRef.diff(currDate,"days");
    		if(total>CT.settings.hotel.totalDuration){
    			return total;
    		}
    		else{
    			return false;
    		}
    	}
	}
	


}
;
